import React from 'react';
import './LoadingSpinner.scss';

type LoadingProps = {
  isButton?: boolean;
};

const LoadingSpinner = ({ isButton }: LoadingProps) => {
  const suffix = isButton ? '-button' : '';

  return (
    <div data-testid="loading-spinner" className={`loading-spinner loading-spinner${suffix}`}>
      <div className={`lds-ring lds-ring-blue lds-ring${suffix} lds-ring-blue${suffix}`}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;